import { useEffect } from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const teamMembers = [
    {
      name: "Ali Batıkan Öcal",
      role: "DEVELOPER",
      bio: "Spor ve teknolojiye tutkun olan Batıkan, saha kiralamayı kolaylaştırmak için HALISAHABUL'U kurdu.",
      image:
        "https://images.unsplash.com/photo-1731964877414-217cdc9b5b37?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Gerçek resim URL'si ile değiştirin
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="py-12 px-4 max-w-6xl mx-auto">
      {/* Başlık */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Hakkımızda</h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          halisahabul'da, saha sahiplerini oyuncularla buluşturarak sporu herkes
          için erişilebilir ve keyifli hale getirmeye adanmış durumdayız.
        </p>
      </div>

      {/* Misyon Beyanı */}
      <div className="bg-white p-8 rounded-lg shadow-md mb-12">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Misyonumuz
        </h2>
        <p className="text-gray-600">
          Sporun insanları bir araya getirme gücüne inanıyoruz. Misyonumuz,
          yüksek kaliteli sahaları bulma ve rezervasyon yapma sürecini
          basitleştirerek sizin sevdiğiniz oyunu oynamaya odaklanmanızı
          sağlamaktır. Kullanıcı dostu bir platform ve mükemmeliyet taahhüdü ile
          spor deneyiminizi yükseltmek için buradayız.
        </p>
      </div>

      {/* Ekip Bölümü */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-800 text-center mb-8">
          Ekibimizle Tanışın
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 place-items-center">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 text-center"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-xl font-semibold text-gray-800">
                {member.name}
              </h3>
              <p className="text-[#4d9041] mb-2">{member.role}</p>
              <p className="text-gray-600">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Harekete Geçirme Çağrısı */}
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Kiralamaya Hemen Başlayın
        </h2>
        <p className="text-gray-600 mb-6">
          Mükemmel sahayı bulmaya hazır mısınız? halisahabul'a güvenen binlerce
          kullanıcıya katılın.
        </p>
        <Link
          to={"/sahalar"}
          className="inline-block bg-[#4d9041] text-white py-3 px-6 rounded-lg hover:bg-[#62a556] transition-colors"
        >
          Başlayın
        </Link>
      </div>
    </section>
  );
};

export default AboutUs;
